/* prettier-ignore */
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { ToolsService } from '../services/tools.service';

export const CanUseRoutesGuard: CanActivateFn = () => {
  const tools = inject(ToolsService);
  const router = inject(Router);

  return tools.commonAppReady$.pipe(
    filter((ready) => ready),
    take(1),
    map(() => (tools.canUseRoutes() ? true : router.parseUrl('/')))
  );
};
